<template>
  <v-container fluid>
    <v-card>
      <v-toolbar dense flat color="secondary">
        <v-toolbar-title>Daily Sale Invoices</v-toolbar-title>
      </v-toolbar>

      <v-card-text>
        <v-row dense class="subtitle-2 text--primary mt-2 mb-2">
          <v-col cols="12" xs="12" md="4" class="subtitle-2 text--primary">
            <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
              offset-y min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field dense outlined single-line v-model="date" label="From" prepend-icon="mdi-calendar-month"
                  v-on="on" readonly></v-text-field>
              </template>
              <v-date-picker @change="fetchRecords" v-model="date" @input="menu1 = false"></v-date-picker>
            </v-menu><br>

            <v-autocomplete autocomplete="off" name="owner" hide-details dense outlined v-model="saleType"
              :items="saleTypes" label="Sale Type" item-text="Name" item-value="id"
              @change="fetchRecords"></v-autocomplete><br>

            <span v-if="hideTotals != 'Y' && hideTotalSales != 'Y'" class="style-24">Total Sales: {{ totalSales |
              currency }}</span>
          </v-col>

          <v-col v-if="hideTotals != 'Y' && hideTotalSales != 'Y'" cols="12" xs="12" offset-md="4" md="4"
            class="subtitle-2 text--primary section-bg mb-2">
            <v-simple-table dense>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>Total Sales</td>
                    <td>{{ totalSales | currency }}</td>
                  </tr>
                  <tr>
                    <td>Delivery Charges</td>
                    <td>{{ totalDelivery | currency }}</td>
                  </tr>
                  <tr>
                    <td>Net Sales</td>
                    <td>{{ (totalSales - totalDelivery) | currency }}</td>
                  </tr>

                  <tr>
                    <td>Total Payments</td>
                    <td>{{ totalPayments | currency }}</td>
                  </tr>

                  <tr>
                    <td>Credit Sales</td>
                    <td v-if="creditSales > 0">{{ creditSales | currency }}</td>
                    <td v-else> 0.0</td>
                  </tr>

                  <tr>
                    <td>Cash Back</td>
                    <td v-if="totalCashBack > 0">{{ totalCashBack | currency }}</td>
                    <td v-else> 0.0</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <v-col cols="12">
            <v-text-field label="Search" v-model="search" outlined dense></v-text-field>
            <!-- start of table -->
            <v-data-table dense :mobile-breakpoint="0" :items-per-page="pageItems"
              :headers="IsDistributor == 'Y' ? distHeaders : headers" :items="dailySales" :search="search">
              <!-- template -->
              <template v-slot:item.DocTotal="{ item }">{{ item.DocTotal | currency }}</template>
              <!-- end -->

              <!-- customer name template -->
              <template v-slot:item.customerPhone="{ item }">
                <span>
                  {{ item.customerName }} - {{ item.customerPhone }}
                </span>
              </template>
              <!-- end -->

              <!-- template -->
              <template v-slot:item.TotalPaid="{ item }">
                {{
                  item.TotalPaid | currency
                }}
              </template>
              <!-- end -->
              <!-- template -->
              <template v-slot:item.Balance="{ item }">
                {{
                  item.Balance | currency
                }}
              </template>
              <!-- end -->

              <!-- template -->

              <template v-slot:item.Date="{ item }">
                <span>{{ formatDateTime(item.Date) }}</span>
              </template>
              <!-- end -->

              <!-- template -->
              <template v-slot:item.DueDate="{ item }">
                {{
                  item.DueDate | date
                }}
              </template>
              <!-- end -->

              <!-- template -->
              <template v-slot:item.payments="{ item }">
                <div v-for="(record, index) in item.payments" :key="index">
                  {{ record.Account.Name }} : {{ record.Amount | currency }}
                </div>
              </template>
              <!-- end -->

              <!-- action template -->
              <template v-slot:item.DocNum="{ item }">
                <v-btn color="accent" text :to="`/sale-preview/${item.id}`">
                  {{ item.DocNum }}
                  <v-icon right>mdi-eye</v-icon>
                </v-btn>
              </template>
              <!-- end -->

              <!-- action template -->
              <template v-slot:item.view="{ item }">
                <v-btn color="accent" :loading="loader" text @click="viewSoldProducts(item.id)">
                  <v-icon left>mdi-eye</v-icon>
                  View Sold Products
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>

        <v-row>
          <v-divider></v-divider>
        </v-row>

        <v-row>
          <v-col cols="12">
            <h3 style="color: red">Cancelled Sales</h3>
          </v-col>

          <v-col cols="12">
            <v-data-table :mobile-breakpoint="0" :search="search" :headers="returnHeaders" :items="returnsData">
              <!-- DocNum template -->
              <template v-slot:item.odln="{ item }">
                <v-btn color="red" text @click="showProducts(item.OdlnId)">
                  <span>{{ item.odln.DocNum }}</span>
                </v-btn>
              </template>
              <!-- end -->

              <!-- DocTotal template -->
              <template v-slot:item.ocrd="{ item }">
                <span style="color: red">{{ item.ocrd.Name }}</span>
              </template>
              <!-- end -->
              <!-- DocTotal template -->
              <template v-slot:item.DocTotal="{ item }">
                <span style="color: red">
                  {{
                    item.DocTotal.toLocaleString()
                  }}
                </span>
              </template>
              <!-- end -->
              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn color="red" text @click="showProducts(item.id)" icon>
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
          </v-col>
        </v-row>

        <!-- Cancelled products dialog -->
        <v-dialog v-model="cancelledDialog" max-width="800px">
          <v-card>
            <v-toolbar dense color="accent" dark>
              <v-toolbar-title>Cancelled/Returned Products</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click.native="cancelledDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container fluid>
                <v-row>
                  <v-col cols="12" xs="12">
                    <h4 style="color: red">Cancelled/Returned products</h4>
                    <v-data-table light :mobile-breakpoint="0" :items-per-page="100" :headers="cancelledHeaders"
                      :items="cancelledData" item-key="id" hide-default-footer>
                      <template v-slot:item.product="{ item }">
                        <span style="color: red">{{ item.product.Name }}</span>
                      </template>

                      <template v-slot:item.Quantity="{ item }">
                        <span style="color: red">{{ item.Quantity }}</span>
                      </template>

                      <template v-slot:item.Price="{ item }">
                        <span style="color: red">
                          {{
                            item.Price.toLocaleString()
                          }}
                        </span>
                      </template>

                      <template v-slot:item.LineTotal="{ item }">
                        <span style="color: red">
                          {{
                            item.LineTotal.toLocaleString()
                          }}
                        </span>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- end of cancelled products modal-->

        <!-- sale preview dialog -->
        <v-dialog v-model="productsDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
          <v-card>
            <v-toolbar flat color="secondary" dense>
              <v-toolbar-title>
                <v-btn icon @click.native="productsDialog = false">
                  <v-icon dark>mdi-keyboard-backspace</v-icon>
                </v-btn>
                Sale Invoice Preview
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click.native="productsDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>

            <v-card-text>
              <v-container class="docForm">
                <v-row justify="center">
                  <v-col cols="10">
                    <v-row class="subtitle-2 text--primary">
                      <v-col cols="12" md="4">
                        <v-simple-table dense>
                          <template v-slot:default>
                            <tbody>
                              <tr>
                                <td>Invoice#:</td>
                                <td>{{ Invoice && Invoice.DocNum }}</td>
                              </tr>
                              <tr>
                                <td>Client:</td>
                                <td>{{ Invoice.Customer && Invoice.Customer.Name }}</td>
                              </tr>
                              <tr>
                                <td>Total Bill:</td>
                                <td>{{ Invoice && Invoice.DocTotal | currency }}</td>
                              </tr>
                              <tr>
                                <td>Discount:</td>
                                <td>{{ Invoice && Invoice.Discount }} %</td>
                              </tr>
                              <tr>
                                <td>Total Paid:</td>
                                <td>{{ Invoice && TotalPaid | currency }}</td>
                              </tr>
                              <tr>
                                <td>Balance:</td>
                                <td>{{ Invoice && Balance | currency }}</td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-col>

                      <v-col cols="12" offset-md="4" md="4">
                        <v-simple-table>
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-left">Account</th>
                                <th class="text-left">Amount Paid</th>
                                <th class="text-left">Ref No</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(item, index) in Payments" v-bind:key="index">
                                <td>{{ item.Account.Name }}</td>
                                <td>{{ item.Amount | currency }}</td>
                                <td>{{ item.PaymentRemarks }}</td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-col>
                    </v-row>

                    <v-divider></v-divider>

                    <v-row dense id="po" class="text--primary subtitle-2 mt-2">
                      <v-col cols="12">
                        <v-data-table dense light :mobile-breakpoint="0" :items-per-page="pageItems"
                          :headers="saleHeaders" :items="SaleRows" item-key="id" hide-default-footer>
                          <template v-slot:item.Name="{ item }">
                            <span style="width: 200px">{{ item.product.Name }}</span>
                          </template>

                          <template v-slot:item.Quantity="{ item }">
                            {{
                              item.Quantity
                            }}
                          </template>

                          <template v-slot:item.Price="{ item }">
                            <span v-if="item.Price">{{ item.Price | currency }}</span>
                          </template>

                          <template v-slot:item.DiscSum="{ item }">
                            {{
                              item.DiscSum
                            }}
                          </template>

                          <template v-slot:item.Discount="{ item }">
                            {{
                              item.Discount
                            }} %
                          </template>

                          <template v-slot:item.LineTotal="{ item }">
                            {{
                              item.LineTotal | currency
                            }}
                          </template>
                        </v-data-table>
                      </v-col>

                      <v-col cols="12">
                        <span style="font-size: 16px; font-weight: bold">Outsourced Products</span>
                        <v-data-table light :mobile-breakpoint="0" :items-per-page="pageItems" :headers="outHeaders"
                          :items="OutsourcedProducts" item-key="id" hide-default-footer>
                          <template v-slot:item.Name="{ item }">
                            <span style="width: 200px">{{ item.Name }}</span>
                          </template>

                          <template v-slot:item.ItemCode="{ item }">
                            <span style="width: 200px">{{ item.ItemCode }}</span>
                          </template>

                          <!-- <template v-slot:item.ref1="{ item }">{{item.ref1}}</template> -->

                          <template v-slot:item.Quantity="{ item }">
                            {{
                              item.Quantity
                            }}
                          </template>

                          <template v-slot:item.Price="{ item }">
                            <span v-if="item.Price">{{ item.Price | currency }}</span>
                          </template>

                          <template v-slot:item.LineTotal="{ item }">
                            {{
                              item.LineTotal | currency
                            }}
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- end of sale preview dialog -->

        <!-- snackbar -->
        <snackbar ref="snackbar"></snackbar>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>

export default {
  data() {
    return {
      hideTotalSales: "N",
      loader: false,
      search: null,
      productsDialog: false,
      IsDistributor: "",
      cancelledDialog: false,
      pageItems: 200,
      date: new Date().toISOString().substr(0, 10),
      menu1: false,
      record: {},
      Invoice: {},
      TotalPaid: 0,
      Balance: 0,
      SaleRows: [],
      OutsourcedProducts: [],
      Payments: [],
      saleType: null,
      saleTypes: [],
      headers: [
        { text: "Doc Num.", value: "DocNum" },
        { text: "Customer", value: "CustomerName" },
        { text: "Phone", value: "customerPhone" },
        { text: "Total", value: "DocTotal" },
        { text: "Paid", value: "TotalPaid" },
        { text: "Balance", value: "Balance" },
        { text: "Cash Back", value: "CashBack" },
        { text: "Sold By", value: "SoldBy" },
        { text: "Date", value: "Date" },
        { text: "View", value: "view" }
      ],
      distHeaders: [
        { text: "Doc Num.", value: "DocNum" },
        { text: "Customer", value: "CustomerName" },
        { text: "Total", value: "DocTotal" },
        { text: "Paid", value: "TotalPaid" },
        { text: "Balance", value: "Balance" },
        { text: "Payments", value: "payments" },
        { text: "Sold By", value: "SoldBy" },
        { text: "Date", value: "Date" },
        { text: "Due Date", value: "DueDate" }
      ],
      returnHeaders: [
        { text: "Invoice No.", value: "odln" },
        { text: "Customer", value: "ocrd" },
        { text: "Return Value", value: "DocTotal" },
        { text: "Date", value: "DocDate" },
        { text: "Date", value: "action" }
      ],
      saleHeaders: [
        { text: "Product", value: "Name" },
        { text: "Qty", value: "Quantity" },
        { text: "Unit", value: "Unit" },
        { text: "Price", value: "Price" },
        { text: "Discount", value: "Discount" },
        { text: "Total", value: "LineTotal" }
      ],
      outHeaders: [
        { text: "Product", value: "Name" },
        { text: "Qty", value: "Quantity" },
        { text: "Unit", value: "Unit" },
        { text: "Price", value: "Price" },
        { text: "Discount", value: "discount" },
        { text: "Total", value: "LineTotal" }
      ],
      dailySales: [],
      totalSales: 0,
      totalDelivery: 0,
      totalPayments: 0,
      creditSales: 0,
      totalCashBack: 0,
      TotalReturns: 0,
      TotalServices: 0,
      returnsData: [],
      cancelledData: [],
      cancelledHeaders: [
        { text: "Product", value: "product" },
        { text: "Qty", value: "Quantity" },
        { text: "Price", value: "Price" },
        { text: "Total", value: "LineTotal" }
      ]
    };
  },
  computed: {
    userId() {
      return localStorage.getItem("userId");
    },
    hideTotals() {
      return localStorage.getItem("HideDebtorsTotal");
    },
    totalSalesValue() {
      let total = 0;
      if (this.totalSales) {
        total = this.totalSales.toLocaleString();
      }
      return total;
    }
  },
  methods: {
    formatDateTime(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
    setDate(date) {
      this.date = date;
    },
    fetchRecords() {
      this.getRecords();
      // this.getReturns();
    },
    viewSoldProducts(val) {
      const self = this;
      this.loader = true;
      // get record
      this.$store
        .dispatch("get", `/sales-invoice/${val}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            var invoice = res.ResponseData;
            self.Invoice = invoice.Invoice;
            self.TotalPaid = invoice.TotalPaid;
            self.Balance = invoice.Balance;
            self.SaleRows = invoice.SaleRows;
            self.OutsourcedProducts = invoice.OutsourcedProducts;
            self.Payments = invoice.Payments;
            self.productsDialog = true;
            self.loader = false;
          } else {
            self.loader = false;
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          self.loader = false;
          this.$refs.snackbar.show(err, "red");
        });
    },
    showProducts(id) {
      const self = this;
      this.$store.commit("loader", true);
      this.$store
        .dispatch("get", `/cancelled-sale-products/${id}`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.cancelledData = res.ResponseData;
            self.$store.commit("loader", false);
            self.cancelledDialog = true;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getRecords() {
      let data = {};
      data.StartDate = this.date;
      data.combinedReport = "N";
      data.saleType = this.saleType;
      const self = this;
      var url = "";
      if (this.IsDistributor == "Y") {
        url = `/daily-distributor-sales-report`;
      }

      if (this.IsDistributor != "Y") {
        url = `/daily-sales-report`;
      }

      console.log(url, " url");

      this.$store.commit("loader", true);
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.dailySales = res.ResponseData.sales;
            self.totalSales = res.ResponseData.totalSales;
            self.totalDelivery = res.ResponseData.totalDelivery;
            this.totalPayments = res.ResponseData.totalPayments;
            this.creditSales = res.ResponseData.creditSales;
            this.totalCashBack = res.ResponseData.totalCashBack;
            // if (res.ResponseData.TotalServices) {
            //   self.TotalServices = res.ResponseData.TotalServices;
            // } else {
            //   self.TotalServices = 0;
            // }

            self.$store.commit("loader", false);
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
            self.$store.commit("loader", false);
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getReturns() {
      const data = {
        StartDate: this.date,
        EndDate: null,
        CustomerID: null
      };
      const self = this;
      const url = `/sales-return-report`;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          console.log(res, "returns");
          if (res.ResultCode == 1200) {
            self.returnsData = res.ResponseData.AllSales;
            self.TotalReturns = res.ResponseData.TotalReturns;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getSaleTypes() {
      const self = this;
      this.$store
        .dispatch("get", `/sale-types`)
        .then(res => {
          self.saleTypes = res.ResponseData;
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getGenSettings() {
      const self = this;
      this.$store
        .dispatch("get", `/general-settings`)
        .then(res => {
          if (res.ResultCode == 1200) {
            if (res.ResponseData) {
              self.IsDistributor = res.ResponseData.IsDistributor;
              self.getRecords();
            }
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    checkExpiry() {
      const self = this;
      const userId = this.subscriberId;
      this.$store
        .dispatch("get", `/users/${userId}`)
        .then((res) => {
          console.log(res.ResponseData, "res g");
          if (res.ResponseData.expiryStatus == 1) {
            self.$router.push("/inactive-account");
          }
        })
        .catch(() => { });
    },
    getUser() {
      const self = this;
      const userId = this.userId;
      this.$store
        .dispatch("get", `/users/${userId}`)
        .then((res) => {
          self.hideTotalSales = res.ResponseData.HideTotalSales;
        })
        .catch(() => { });
    },
  },
  created() {
    // this.getSaleTypes();
    this.getGenSettings();
    this.checkExpiry();
    this.getUser();
    // this.getReturns();
  }
};
</script>

<style lang="scss" scoped></style>